import Cookie from '@wetransfer/concorde-cookie';

import { AppConfig } from '../core-bundle/config/app-config';

import Store from '@app/store';
import SplashpageHelper from '@app/helper/splashpage';

import Router from '@module/router';
import Analytics from '@module/analytics';

const currentLocation = location.href;

// https://code2flow.com/Ij8JKL : contains all the logic to open/not open the Panel
export const init = () => {
  if (SplashpageHelper.shouldDisplaySplashpage()) {
    return;
  }

  const { route, user, session, channel } = Store.getState();
  const locationChanged = currentLocation !== location.href;

  // Don't do this on small windows (because it will force full panel)
  if (window.innerWidth <= 1050) {
    return;
  }

  // If T&C are not accepted
  if (!session.tandc) {
    return;
  }

  // Don't show on channels
  if (channel && channel.name) {
    return;
  }

  // Only show this on the homepage (this also catches Splashpage route: /welcome)
  if (route.path !== '/' || locationChanged) {
    return;
  }

  // User logged in or is a Plus user so stop!
  if (user.loggedIn || Cookie.get(AppConfig.cookies.plus.name)) {
    return;
  }

  const showPanel = (trk = 'WT201610_HalfPanel_Triggered') => {
    const { route } = Store.getState();
    if (!route.isPanelOpen) {
      Cookie.set('wt_wp', 1, { days: 365 });

      Analytics.trackSnowplowEvent({
        category: 'plus',
        action: 'show_halfpanel_triggered',
      });

      Router.navigateTo('/log-in', Router.SILENT, {
        search: `trk=${trk}`,
      });
    }
  };

  // Don't open if Panel was already opened before
  if (!Cookie.get('wt_wp')) {
    setTimeout(showPanel, AppConfig.panel.openDelay);
  }
};
